<template>
  <div
    id="app"
    :class="{
      fixed: broadcastVodInfo.bcScheduleSysId && !broadcastVodInfo.pipMode,
      native: isNative,
      notch: isNotch,
      aosApp: isAos,
      iosApp: isIosApp,
      isBtmNavHidden: !btmNav,
      isMobile: isMobile,
      isBlack : isBlack,
      demo : this.$route.name !== 'Home' 
    }"
  >
      <!-- <div
      class="pop"
      :class="{ top: popCon }"
      @click.self="changePop"
      v-if="popVisible && isMobileWeb"
    >
      <section class="popWrap">
        <button class="popClose" @click="changePop"></button>
        <div class="txt">
          <div class="imgBox">
          </div>
          <div class="col">
            <p>APP 설치하면</p>
            <h1><span>신규회원 {{joinCoupon.discountAmount | makeComma}}원 할인쿠폰</span> 증정</h1>
          </div>
        </div>
        <router-link @click.native.prevent="clickLink" target="_blank" class="appInstall" to=""></router-link>
        <div class="ctArea">
          <button class="txtClose" @click="changePop">불편하지만 모바일 웹으로 보기</button>
        </div>
      </section>
    </div> -->
      <PastVod
        v-if="broadcastVodInfo.vodPlaying && broadcastVodInfo.type === 'vod'"
        ref="pipBox"
        :broadcastVodInfo="broadcastVodInfo"
        :style="{
          top: broadcastVodInfo.top + 'px',
          right: broadcastVodInfo.right + 'px'
        }"
        :class="{
          magnet: magnetClass
        }"
      ></PastVod>
      <LivePlayer
        v-if="broadcastVodInfo.vodPlaying && broadcastVodInfo.type === 'live'"
        ref="pipBox"
        :broadcastVodInfo="broadcastVodInfo"
        :style="{
          top: broadcastVodInfo.top + 'px',
          right: broadcastVodInfo.right + 'px'
        }"
        :class="{
          magnet: magnetClass
        }"
      ></LivePlayer>
      <router-view
        v-if="ready"
        :class="{
          fixed:
            (popVisible && !popCon && isMobileWeb) ||
            (broadcastVodInfo.vodPlaying && !broadcastVodInfo.pipMode)
        }"
      />

      <bottom-navigation v-if="btmNav" />
  </div>
</template>

<style lang="css" src="@/assets/css/flowplayer.css"></style>
<style lang="scss" src="@/assets/css/common.scss"></style>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import {
  AppBridge,
  isTokenExpired,
  sellerCheck,
  joinCoupon,
  AlertChek
} from '@/assets/js/common.js'
import PastVod from '@/view/liveInfo/PastVod'
import LivePlayer from '@/view/liveInfo/LivePlayer'
import {
  getRefressToken,
  getAccessToken,
  getUserInfo,
  trackVisit
} from '@/api/index.js'
import TokenServices from '@/service/tokenService'
import TranslateService from '@/service/TranslateService'
import DEFINE from '@/service/DEFINE'
import BottomNavigation from './components/shared/BottomNavigation.vue'

export default {
  name: 'App',
  components: {
    PastVod,
    LivePlayer,
    BottomNavigation,
  },
  data() {
    return {
      isIosApp: false,
      popCon: false,
      popVisible: false,
      isMobileWeb: false,
      isKakaoTalk: false,
      isFaceBook: false,
      ready: false,
      broadcastVodInfo: {
        bcSysId: null,
        bcScheduleSysId: null,
        vodPlaying: false,
        pipMode: false,
        type: null,
        top: 0,
        right: 0
      },
      touch: {
        startX: null,
        endX: null,
        startY: null,
        endY: null,
        startTime: null,
        endTime: null
      },
      pipAction: {
        startX: null,
        startY: null
      },
      magnetClass: false,
      appLinkUrl: '',
      pipBox: null,
      changeBlock: false,
      joinCoupon: {},
      isNative: false,
      isMobile: false,
      isBlack: false,

      // 점검중입니다.
      isMaintenance: false
    }
  },

  computed: {
    ...mapState(['isLogin', 'webVersion']),
    ...mapState('variableStore', ['isNotch']),
    ...mapGetters('variableStore', ['isAos']),

    btmNav() {
      if (
        this.$route.name &&
        this.$route.name !== 'Home' &&
        this.$route.name !== 'Wiznft'
      ) {
        return true
      }

      return false
    }
  },
  watch : {
    $route: {
      handler(n) {
        if (
          n.name === 'Login' ||
          n.name === 'DemoHome' ||
          n.name === 'RegStep00' ||
          n.name === 'RegStep04' ||
          n.name === 'Store' ||
          n.name === 'Category' ||
          n.name === 'Basket' ||
          n.name === 'LiveItems' ||
          n.name === 'ViewLog' ||
          n.name === 'Search' ||
          n.name === 'MyPoint' ||
          n.name === 'MyPage' ||
          n.name === 'AlertSet' ||
          n.name === 'Coupon' ||
          n.name === 'ModifyProfile' ||
          n.name === 'ChangePw' ||
          n.name === 'Withdraw'
        ) {
          document.querySelector('body').style.backgroundColor = '#000'
          this.isBlack = true
        } else {
          document.querySelector('body').style.backgroundColor = '#fff'
          this.isBlack = false
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      loginSuccess: 'loginSuccess',
      loginError: 'loginError'
    }),
    ...mapActions(['isDemo']),

    ...mapMutations('variableStore', ['setIsNotch']),

    liveExit(obj) {
      if (!this.selectedItem) {
        return false
      }

      let liveExitFlag = parseInt(JSON.parse(obj).value)
      let vodInfo = {
        broadcastSysId: this.selectedItem.broadcastSysId,
        broadcastScheduleSysId: this.selectedItem.broadcastScheduleSysId,
        vodPlaying: true
      }
      if (liveExitFlag) {
        console.log('live닫힘')
        window.pastVod(vodInfo)
      } else {
        console.log('live없음')
        window.pastVod(vodInfo)
      }
    },
    clickLink() {
      let userAgent = navigator.userAgent.toLowerCase()
      let visiteTm = new Date().getTime()
      let qs = ''
      for (const key in this.$route.query) {
        if (this.$route.query.hasOwnProperty(key)) {
          const el = this.$route.query[key]
          qs += `${key}=${el}:`
        }
      }

      qs = qs.substring(0, qs.length - 1)

      if (this.orderCodeForApp) {
        qs = `orderCode=${this.orderCodeForApp}`
      }

      let link = ''

      if (userAgent.indexOf('android') > -1) {
        link = ``

        window.open(link, '_blank')
      } else {
        if (qs) {
          let keys = Object.keys(this.$route.query)
          let values = Object.values(this.$route.query)

          link = ``
        } else {
          link = ``
        }

        setTimeout(() => {
          if (new Date().getTime() - visiteTm < 3000) {
            location.href = ''
          }
        }, 500)
        setTimeout(() => {
          location.href = link
        }, 0)
      }
    },
    changePop() {
      let target = document.querySelector('.pop')
      if (target.classList.contains('top')) {
        this.closePop()
      } else {
        this.popCon = true
        sessionStorage.setItem('popCon', true)
      }
    },
    closePop() {
      let target = document.querySelector('.pop')
      sessionStorage.setItem('popVisible', true)
      target.parentNode.removeChild(target)
    },

    routeGo(obj) {
      let prdtSysId = JSON.parse(obj).prdtSysId
      let broadcastScheduleSysId = JSON.parse(obj).broadcastScheduleSysId

      this.$router.push(`/product/${prdtSysId}/Live/${broadcastScheduleSysId}`)
    },

    routeGo2(obj) {
      let brandSysId = JSON.parse(obj).value
      this.$router.push(`/Planning/brandList/${brandSysId}`)
    },

    vodPip(obj) {
      if (this.changeBlock) return false

      this.changeBlock = true
      setTimeout(() => {
        this.changeBlock = false
      }, 500)

      this.broadcastVodInfo = {
        bcSysId:
          obj.broadcastSysId !== undefined
            ? obj.broadcastSysId
            : this.broadcastVodInfo.bcSysId,

        bcScheduleSysId:
          obj.broadcastScheduleSysId !== undefined
            ? obj.broadcastScheduleSysId
            : this.broadcastVodInfo.bcScheduleSysId,

        vodPlaying:
          obj.vodPlaying !== undefined
            ? obj.vodPlaying
            : this.broadcastVodInfo.vodPlaying,

        pipMode: obj.pipMode !== undefined ? obj.pipMode : false,

        type: obj.type ? obj.type : this.broadcastVodInfo.type,

        top: obj.top !== undefined ? obj.top : 0,

        right: obj.right !== undefined ? obj.right : 0
      }

      if (!this.pipBox) {
        this.pipBox = document.querySelector('.pastvodWrap')
      }

      if (obj.pipMode) {
        this.pipInit()
      } else if (!obj.pipMode) {
        this.pipRemove()
        this.pipBox = null
      }
    },

    touchMove(e) {
      let pipBox = document.querySelector('.pVodSizingBtn')
      if (e.target === pipBox) {
        let width = window.innerWidth
        this.broadcastVodInfo.right =
          width - (e.changedTouches[0].pageX + this.pipAction.startX)
        this.broadcastVodInfo.top =
          e.changedTouches[0].pageY - this.pipAction.startY
      }

      e.stopImmediatePropagation()
      return false
    },

    touchStart(e) {
      let pipBox = document.querySelector('.pVodSizingBtn')
      if (e.target === pipBox) {
        this.touch.startX = e.changedTouches[0].pageX
        this.touch.startY = e.changedTouches[0].pageY
        this.pipAction.startX =
          window.innerWidth - this.touch.startX - this.broadcastVodInfo.right
        this.pipAction.startY = this.touch.startY - this.broadcastVodInfo.top
        document.querySelector('html').style.height = 'auto'
        document.querySelector('html').style.overflow = 'hidden'
      }
    },

    touchEnd(e) {
      let pipBox = document.querySelector('.pVodSizingBtn')
      if (e.target === pipBox) {
        this.touch.endX = e.changedTouches[0].pageX
        this.touch.endY = e.changedTouches[0].pageY
        this.touch.endTime = e.timeStamp
        this.moveEnd()
        setTimeout(function () {
          document.querySelector('html').removeAttribute('style')
        }, 50)
      }
    },

    moveEnd() {
      let limitLand = ((window.pastVodPip.pipWidth * 2) / 3) * -1
      let limitVer = ((window.pastVodPip.pipHeight * 2) / 3) * -1
      if (
        this.broadcastVodInfo.right + window.pastVodPip.pipWidth / 2 <
        window.innerWidth / 2
      ) {
        if (this.broadcastVodInfo.right < limitLand) {
          this.Magnet('rightOut')
        } else {
          if (this.broadcastVodInfo.top < limitVer) return this.Magnet('topOut')
          if (
            this.broadcastVodInfo.top >
            window.innerHeight - window.pastVodPip.pipHeight + limitVer * -1
          )
            return this.Magnet('bottomOut')
          this.Magnet('right')
        }
      } else {
        if (
          this.broadcastVodInfo.right >
          window.innerWidth - window.pastVodPip.pipWidth + limitLand * -1
        ) {
          this.Magnet('leftOut')
        } else {
          if (this.broadcastVodInfo.top < limitVer) return this.Magnet('topOut')
          if (
            this.broadcastVodInfo.top >
            window.innerHeight - window.pastVodPip.pipHeight + limitVer * -1
          )
            return this.Magnet('bottomOut')
          this.Magnet('left')
        }
      }
    },

    Magnet(dir) {
      this.magnetClass = true
      let _this = this

      switch (dir) {
        case 'left':
          this.broadcastVodInfo.right =
            window.innerWidth - window.pastVodPip.pipWidth
          if (this.broadcastVodInfo.top < 0) this.broadcastVodInfo.top = 0
          if (
            this.broadcastVodInfo.top >=
            window.innerHeight - window.pastVodPip.pipHeight
          )
            this.broadcastVodInfo.top =
              window.innerHeight - window.pastVodPip.pipHeight
          break
        case 'right':
          this.broadcastVodInfo.right = 0
          if (this.broadcastVodInfo.top < 0) this.broadcastVodInfo.top = 0
          if (
            this.broadcastVodInfo.top >=
            window.innerHeight - window.pastVodPip.pipHeight
          )
            this.broadcastVodInfo.top =
              window.innerHeight - window.pastVodPip.pipHeight
          break
        case 'leftOut':
          this.broadcastVodInfo.right = window.innerWidth
          break
        case 'rightOut':
          this.broadcastVodInfo.right = window.pastVodPip.pipWidth * -1
          break
        case 'topOut':
          this.broadcastVodInfo.top = window.pastVodPip.pipHeight * -1
          break
        case 'bottomOut':
          this.broadcastVodInfo.top =
            window.pastVodPip.pipHeight + window.innerHeight
          break
      }
      setTimeout(function () {
        _this.magnetClass = false

        if (
          dir === 'leftOut' ||
          dir === 'rightOut' ||
          dir === 'topOut' ||
          dir === 'bottomOut'
        ) {
          this.closePip()
        }
      }, 400)
    },

    closePip() {
      let vodInfo = {
        broadcastSysId: null,
        broadcastScheduleSysId: null,
        vodPlaying: false,
        pipMode: false,
        type: null,
        top: 0,
        right: 0
      }

      window.pastVod(vodInfo)
      AppBridge.send('VodPipExit', { value: 'close' }, true)

      this.pipRemove()
    },

    pipInit() {
      this.broadcastVodInfo.top = 0
      if (this.isNative && !this.isNotch) {
        this.broadcastVodInfo.top = 30
      }
      this.broadcastVodInfo.right = 0

      this.touch = {
        startX: null,
        endX: null,
        startY: null,
        endY: null,
        startTime: null,
        endTime: null
      }

      this.pipBox.addEventListener('touchstart', this.touchStart, {
        capture: true
      })
      this.pipBox.addEventListener('touchmove', this.touchMove, {
        capture: true
      })
      this.pipBox.addEventListener('touchend', this.touchEnd, { capture: true })
    },

    pipRemove() {
      if (this.pipBox) {
        if (this.isNative) {
          this.broadcastVodInfo.top = 0
        }
        this.pipBox.removeEventListener('touchstart', this.touchStart, {
          capture: true
        })
        this.pipBox.removeEventListener('touchmove', this.touchMove, {
          capture: true
        })
        this.pipBox.removeEventListener('touchend', this.touchEnd, {
          capture: true
        })
      }
    },

    switchPipMode(obj) {
      let pipObj = JSON.parse(obj).value
      if (pipObj === 'full') {
        let pipInfo = {
          pipMode: true,
          right: 0,
          left: 0,
          top: 0
        }

        this.vodPip(pipInfo)
        AppBridge.send('VodScreenStatus', { value: true }, true)
      } else if (pipObj === 'pip') {
      }
    },

    streamExit(obj) {
      let res = JSON.parse(obj).value
      if (res === 'true') {
        sessionStorage.setItem('sallyTab', 2)
        this.$router.replace('/seller/sellerList')
      } else {
        sessionStorage.setItem('sallyTab', 1)
        this.$router.replace('/seller/sellerList')
      }
    },

    refreshFunc() {
      this.$router.go()
    },

    contactsData(obj) {
      sessionStorage.setItem('phoneBook', obj)
    },
    getNotificationTopic(obj) {
      if (obj) {
        AlertChek(sessionStorage.getItem('accessToken'))
      }
    },

    setWebLanguage(obj) {
      let lang = JSON.parse(obj).value
      console.log('language', lang)

      if (lang === undefined || !lang) {
        lang = 'ko'
      }
      this.$i18n.locale = lang
      localStorage.setItem('locale', lang)
    },

    routerBridge(obj) {
      if (obj) {
        // alert(JSON.parse(obj) + '\n이동될 라우팅 url: ' + window.DEFINE.BRIDGE.ROUTER[JSON.parse(obj).value])
        if (JSON.parse(obj).value === 5 && !this.isLogin) {
          return alert('로그인이 필요한 서비스 입니다.')
        }
        this.$router.push(window.DEFINE.BRIDGE.ROUTER[JSON.parse(obj).value])
      }
    },

    nativeBtmNavSwitch(boolean) {
      AppBridge.send(
        'visibleBtmNavBar',
        JSON.stringify({ value: boolean }),
        true
      )
    },

    responsiveScreen() {
      const UA = navigator.userAgent.toLowerCase()
      if (UA.includes('mobile')) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },

    setNotch(obj) {
      const isNotch = JSON.parse(obj).value === 'true'

      this.setIsNotch(isNotch)
    }
  },

  async beforeCreate() {
    // 점검중입니다.
    if (this.isMaintenance) {
      this.$router.replace('/Maintenance')
    }

    window.DEFINE = DEFINE
    if (!window.TokenService) {
      window.TokenService = await new TokenServices()
    }

    let UA = navigator.userAgent.toLowerCase()
    if (UA.indexOf('native') > -1) {
      this.isNative = true
    }
    if (this.isNative && UA.indexOf('ios') > -1) {
      this.isIosApp = true
      AppBridge.set('webVersion', JSON.stringify({ value: this.webVersion }))
    } else if (UA.includes('kakaotalk')) {
      this.isKakaoTalk = true
    }

    if (this.isNative) {
      window.receiveApp = AppBridge.receiveApp
      window.routeGo = this.routeGo
      window.routeGo2 = this.routeGo2
      window.switchPipMode = this.switchPipMode
      window.streamExit = this.streamExit
      window.refreshFunc = this.refreshFunc
      window.contactsData = this.contactsData
      window.getNotificationTopic = this.getNotificationTopic
      window.setWebLanguage = this.setWebLanguage
      window.routerBridge = this.routerBridge
      window.nativeBtmNavSwitch = this.nativeBtmNavSwitch
      window.liveExit = this.liveExit
      window.setNotch = this.setNotch
    }
    window.pastVod = this.vodPip
    window.closePip = this.closePip

    if (this.isNative) {
      AppBridge.get('saveUser')
      AppBridge.get('setWebLanguage')
      AppBridge.get('phoneNameChk')
      AppBridge.get('notch')
    }

    // 언어 초기화
    if (!localStorage.getItem('locale')) {
      let localeStr = navigator.language || navigator.userLanguage
      let locale = null
      locale = localeStr.substring(0, 2)

      this.$i18n.locale = locale
      localStorage.setItem('locale', locale)
    }

    window.TranslateService = await new TranslateService()

    let saveUser = null
    if (this.isIosApp) {
      saveUser = await AppBridge.read('saveUser')
      if (saveUser !== '') {
        saveUser = JSON.parse(saveUser)
      }
    } else {
      if (localStorage.getItem('saveUser')) {
        if (JSON.parse(localStorage.getItem('saveUser')).refreshToken) {
          saveUser = JSON.parse(localStorage.getItem('saveUser'))
        } else {
          localStorage.removeItem('saveUser')
        }
      }
    }

    let isRefreshExpired = null
    if (saveUser) {
      if (saveUser.id) {
        if (this.isIosApp) {
          AppBridge.delete('saveUser')
        } else {
          localStorage.removeItem('saveUser')
        }
      } else {
        isRefreshExpired = isTokenExpired(saveUser.refreshToken, 'refreshToken')
      }
    }

    if (isRefreshExpired === 30 && saveUser) {
      alert('오랫동안 활동이 없어, 재로그인이 필요합니다.')
      this.$store.dispatch('logOut')
      this.ready = true
    } else if (isRefreshExpired === 14 && saveUser) {
      try {
        let res = await getRefressToken(saveUser.refreshToken)
        if (res.data.jsonData.resultCode === '0001') {
          sessionStorage.setItem('refreshToken', res.data.jsonData.refreshToken)
          sessionStorage.setItem('accessToken', res.data.jsonData.accessToken)
          sessionStorage.setItem(
            'setGroupChk',
            JSON.stringify({
              id: res.data.jsonData.groupIds || '0',
              flag: res.data.jsonData.groupIds ? true : false
            })
          )
          AppBridge.send(
            'fcmAccesstoken',
            JSON.stringify({ accessToken: res.data.jsonData.accessToken }),
            true
          )

          if (this.isIosApp) {
            AppBridge.set(
              'saveUser',
              JSON.stringify({ refreshToken: res.data.jsonData.refreshToken })
            )
            AppBridge.get('pastContractList')
          } else {
            localStorage.setItem(
              'saveUser',
              JSON.stringify({ refreshToken: res.data.jsonData.refreshToken })
            )
          }

          sellerCheck(res.data.jsonData.accessToken)
          if (this.isNative) {
            this.getNotificationTopic()
          } else {
            AlertChek(res.data.jsonData.accessToken)
          }

          this.ready = true
          window.TokenService._setToken()

          this.loginSuccess()
        } else {
          this.ready = true
        }
      } catch (err) {
        console.error(err)
        this.ready = true
      }
    } else if (saveUser) {
      try {
        let res = await getAccessToken(saveUser.refreshToken)
        if (res.data.jsonData.resultCode === '0001') {
          sessionStorage.setItem('refreshToken', saveUser.refreshToken)
          sessionStorage.setItem('accessToken', res.data.jsonData.accessToken)
          sessionStorage.setItem(
            'setGroupChk',
            JSON.stringify({
              id: res.data.jsonData.groupIds || '0',
              flag: res.data.jsonData.groupIds ? true : false
            })
          )
          AppBridge.send(
            'fcmAccesstoken',
            JSON.stringify({ accessToken: res.data.jsonData.accessToken }),
            true
          )
          if (this.isIosApp) {
            AppBridge.get('pastContractList')
          }
          sellerCheck(res.data.jsonData.accessToken)

          if (this.isNative) {
            this.getNotificationTopic()
          } else {
            AlertChek(res.data.jsonData.accessToken)
          }

          this.ready = true
          window.TokenService._setToken()

          this.loginSuccess()
        } else if (res.data.jsonData.resultCode === '1003') {
          this.loginError()
          this.ready = true
          this.$router.push('/demo')
        } else {
          this.ready = true
        }
        this.ready = true
      } catch (err) {
        console.error(err)
        this.ready = true
      }
    } else {
      this.ready = true
      sessionStorage.setItem(
        'setGroupChk',
        JSON.stringify({ id: '0', flag: false })
      )
    }
    this.ready = true

    if (sessionStorage.getItem('accessToken')) {
      let uRes = await getUserInfo(sessionStorage.getItem('accessToken'))
      console.log(uRes)
      if (uRes.data.jsonData.resultCode === '0001') {
        sessionStorage.setItem('nickName', uRes.data.jsonData.nickName)
        sessionStorage.setItem('userSysId', uRes.data.jsonData.userSysId)
      }
    }

    this.joinCoupon = await joinCoupon()
    if (this.joinCoupon.discountAmount > 0) {
      if (
        !sessionStorage.getItem('popVisible') &&
        !sessionStorage.getItem('popCon')
      ) {
        this.popCon = false
        this.popVisible = true
      } else if (sessionStorage.getItem('popVisible')) {
        this.popCon = false
        this.popVisible = false
      } else if (!this.isNative) {
        this.popCon = true
        this.popVisible = true
      }
    }

    if (!this.isNative) {
      var filter = 'win16|win32|win64|mac|macintel'
      if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
        this.isMobileWeb = true
      }
    }
  },

  mounted: function () {
    window.isDemo = this.isDemo

    this.responsiveScreen()

    // 다시보기 pip 모드 사이즈 지정.
    window.pastVodPip = {
      pipWidth: window.innerWidth * 0.26,
      pipHeight: window.innerHeight * 0.26
    }

    window.onpopstate = (event) => {
      if (
        sessionStorage.getItem('accessToken') === null &&
        this.$route.path === '/MyPage'
      ) {
        this.$router.push('/demo')
      }
    }
  },
  beforeDestroy() {
    if (sessionStorage.getItem('buyInputData')) {
      sessionStorage.removeItem('buyInputData')
    }
  }
}
</script>

<style lang="scss">
#app.fixed {
  overflow: hidden;
  height: 100%;
  box-sizing: border-box;
}

#app {
  & > .appScr {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
.isBlack{
  background:#000;
}
</style>
